var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "news-section list__mod" },
    [
      _c("header-inner"),
      _c(
        "wrapper",
        { attrs: { "line-borders": false, "line-center": true } },
        [
          _c("menu-news", {
            on: {
              currentMenu: function($event) {
                _vm.currentMenu($event)
              }
            }
          }),
          _vm.entitiesLoaded
            ? _c(
                "section",
                [
                  _c("div", { staticClass: "title-main" }, [
                    _c("h1", {
                      domProps: { innerHTML: _vm._s(this.social.title) }
                    })
                  ]),
                  _vm.mainImage
                    ? _c(
                        "news-Big-slide",
                        {
                          staticClass: "big-slide",
                          attrs: {
                            image: this.social.image_detailed
                              ? this.social.image_detailed
                              : _vm.mainImage.image,
                            buttonShow: false
                          }
                        },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(this.social.text) }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._l(_vm.entities, function(item) {
                    return _vm.entities
                      ? _c("card-news-small", {
                          key: item.id,
                          attrs: {
                            title: item.title,
                            image: item.image,
                            id: item.id,
                            link: item.url,
                            date: item.date,
                            linkTo: "/news/social/" + item.id,
                            text: item.text
                          }
                        })
                      : _vm._e()
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3694edc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3694edc0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/news/social.vue
// module id = VqMI
// module chunks = 1